<template>
  <div class="main frame-home">
    <div class="frame-bg" :class="{ 'slide-left': slidePage }">
      <img class="frame-img" src="/assets/images/frame-home.webp" alt />
      <img class="frame-extention" src="/assets/images/home-extention.webp" alt />
      <img
        class="img-overlay"
        :class="{ shadow: hoverHero }"
        src="/assets/images/hero-home.webp"
        alt
      />
      <map name="mapframe">
        <area
          shape="poly"
          coords="1025,535,1055,500,1085,510,1125,560,1150,630,1120,680,1140,855,1100,880,1010,880,935,800"
          href="#"
          @click="openSilentBox"
          @mouseover="hoverHero = true"
          @mouseleave="hoverHero = false"
        />
      </map>
      <img
        class="img-overlay img-front"
        src="/assets/images/map.webp"
        usemap="#mapframe"
        alt
      />
    </div>
    <div class="frame-overlay"></div>
    <leaves></leaves>
    <div class="frame-content container-fluid fade-in" :class="{ 'fade-out': slidePage }">
      <div class="frame-text">
        <h1 class="frame-heading mb-4">
          FIGHT FOR VALHALLA,<br />
          FEAST LIKE GODS!
        </h1>
        <p class="lead">
          Become a Warrior in Norse Land and fight with enemies.<br />
          Create a deck and build a strategy with unique NFTs<br />
          that lead you to victory.
        </p>
      </div>
    </div>
    <div class="next-page fade-in" :class="{ 'fade-out': slidePage }">
      <a class="nav-link fade-in" to="/road" @click="goToRoad">
        <span>Road to Valhalla</span>
        <fa :icon="['fas', 'play']" class="fa-2x" />
      </a>
    </div>
    <div
      class="watch-trailer"
      :class="{ 'fade-out': slidePage }"
      @mouseover="hoverHero = true"
      @mouseleave="hoverHero = false"
    >
      <a @click="openSilentBox">Watch Trailer</a>
    </div>
    <div class="play-button fade-in" :class="{ 'fade-out': slidePage }">
      <a @click="openPlayBox" class="btn btn-lg btn-primary">Play Demo</a>
    </div>
  </div>
</template>

<script>
import imageMapResize from "image-map-resizer";
import Leaves from "@/components/Leaves.vue";

export default {
  data() {
    return {
      hoverHero: false,
      slidePage: false,
      video: {
        src: "https://www.youtube.com/watch?v=IM_4-XFeRyA",
        description: "Sunken dreams II. by Arbebuk",
        autoplay: true,
        controls: false,
      },
      image: {
        src: "/assets/images/arena.webp",
      },
    };
  },
  mounted() {
    window.addEventListener("resize", this.windowResize);
    setTimeout(() => imageMapResize(), 50);

    setInterval(() => {
      if (!this.hoverHero) {
        this.hoverHero = true;
        setTimeout(() => (this.hoverHero = false), 500);
      }
    }, 5000);
  },
  updated() {
    setTimeout(() => imageMapResize(), 50);
  },
  unmounted() {
    window.removeEventListener("resize", this.windowResize);
  },
  methods: {
    windowResize(e) {
      imageMapResize();
    },
    openSilentBox() {
      this.$silentbox.open(this.video);
    },
    openPlayBox() {
      this.$silentbox.open(this.image);
    },
    goToRoad() {
      this.slidePage = true;
      setTimeout(() => this.$router.push("/road"), 500);
    },
  },
  components: {
    Leaves,
  },
};
</script>

<style lang="scss" scoped>
.frame-home {
  position: relative;
  width: 100%;
  overflow: hidden;
  .frame-bg {
    position: relative;
    left: 0;
    height: 100%;
    width: 100%;
    .frame-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      min-height: 100vh;
      transition: transform 1s ease-in-out;
    }
    .frame-extention {
      position: absolute;
      left: 50%;
      height: 100%;
      top: 0;
      bottom: 0;
      object-fit: cover;
      object-position: left;
    }
    .img-overlay {
      object-fit: cover;
      position: absolute;
      height: 100%;
      min-height: 100vh;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      -webkit-transition: -webkit-filter 500ms linear;
      &.shadow {
        -webkit-filter: drop-shadow(0px 0px 1rem #ffeca6);
        filter: drop-shadow(0px 0px 1rem #ffeca6);
      }
    }
    .img-front {
      z-index: 4;
    }
  }
  .frame-overlay {
    position: absolute;
    z-index: 3;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(180deg, #333333 0%, rgba(51, 51, 51, 0) 33%);
  }

  .frame-content {
    position: absolute;
    z-index: 3;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    .frame-text {
      padding-left: 3rem;
      margin-bottom: 10rem;
      @media (max-width: 1365.98px) {
        margin-bottom: 8rem;
      }
      @media (max-width: 1199.98px) {
        margin-bottom: 6rem;
      }
      .frame-heading {
        color: #ffeec2;
        text-transform: uppercase;
      }
    }
    @media (max-width: 767.98px) {
      justify-content: flex-start;
      .frame-text {
        padding-left: 1rem;
        margin-top: 6rem;
        p {
          margin-bottom: 0.5rem;
        }
      }
    }
  }

  .next-page {
    position: absolute;
    right: 1em;
    top: 50%;
    transform: translateY(-50%);
    line-height: 2;
    font-size: 1rem;
    font-size: max(1rem, 18px);
    z-index: 5;
    opacity: 1;
    @media (max-width: 767.98px) {
      top: 92%;
    }
    a {
      color: #ffeec2;
      text-decoration: none;
      display: flex;

      span {
        margin-right: 0.5rem;
      }

      &:hover {
        color: #fff;
      }
    }
  }

  .watch-trailer {
    color: #ffeec2;
    position: absolute;
    left: 60%;
    left: max(60%, 690px);
    top: 53%;
    transform: translateY(-50%);
    z-index: 5;
    text-decoration: none;
    cursor: pointer;
    text-shadow: 0 0 10px black;
    border-bottom: 1px solid #ffeec2;
    font-size: 1rem;
    font-size: max(1rem, 18px);
    line-height: 20px;
    opacity: 1;
    &:after {
      position: absolute;
      content: url("/assets/images/watch-trailer.png");
      left: -31px;
      top: 100%;
      height: 76px;
      width: 13px;
    }
    &:hover {
      color: #fff !important;
    }
  }

  .play-button {
    position: absolute;
    left: 3.6rem;
    top: 60%;
    transform: translateY(-50%);
    z-index: 5;
    opacity: 1;
    @media (max-width: 767.98px) {
      left: 2rem;
    }
  }

  .slide-left {
    left: -100vh;
    transition: left 0.5s ease-in-out;
  }
  .fade-out {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }
}
</style>
